import { ACTION_EVENTS } from "./UserAction";
import { AUTOSTART_EVENTS } from "../game/GameAutostart";
import events from "../events/EventsObservable";
import { GAME_EVENTS } from "../game/gameEvents";

export default class WakeLockHandler {
    private _wakeLock: any = null
	private _inAutostart: boolean = false
	private _active: boolean = false
	private static instance: WakeLockHandler

    private constructor() {
		//@ts-ignore
		if ('wakeLock' in navigator) {
			const off = ()=> {
				if(this._wakeLock !== null) {
					try {
						this._wakeLock.release();
						this._wakeLock = null;
						this._active = false;
					}
					catch(e) {
						console.log(`Wake Lock Release Error: ${e.name}, ${e.message}`);
					}
				}
			}
			const on = async ()=>{
                if(!this._active && this._wakeLock === null) {
                    try {
						this._active = true
                        //@ts-ignore
                        this._wakeLock = await navigator.wakeLock.request('screen');
						this._inAutostart = true
                    } catch (e) {
                        console.log(`Wake Lock Request Error: ${e.name}, ${e.message}`);
                    }
                }
            }
			events.subscribe(GAME_EVENTS.GAME_FREESPIN_END, ()=>{
				off()
				this._inAutostart = false
			})
			events.subscribe(ACTION_EVENTS.ACTION_AUTOSTART_STOP, ()=>{
				off()
				this._inAutostart = false
			})

            events.subscribe(AUTOSTART_EVENTS.AUTOSTART_ON_SET_COUNT, (eventName, value)=>{
                if(value.count === 0) {
					off()
					this._inAutostart = false
                } else {
					on()
				}
            })

			events.subscribe(GAME_EVENTS.GAME_ENTER_FREESPINS, on)
			document.addEventListener('visibilitychange', async ()=>{
				if (document.hidden) {
					off()
				} else {
					if(this._inAutostart)
						on()
				}
			})
		}
    }

	public static getInstance(): WakeLockHandler {
		if(!WakeLockHandler.instance) {
			WakeLockHandler.instance = new WakeLockHandler()
		}

		return WakeLockHandler.instance
	}
}